import { useEffect } from 'react'

/**
 * Natív sima gorgetes + gorgetesre belepo elemek.
 *
 * MIERT NEM KULSO GORGETESI KONYVTAR A BELEPESHEZ:
 * A gorgetest elfogo megoldasok nem minden esetben kapnak sajat esemenyt -
 * peldaul horgonylink, `scrollTo`, billentyuzet vagy oldalon beluli kereses
 * eseten. Ilyenkor a felhasznalo egy meg rejtett szakaszra erkezhetne.
 *
 * Az IntersectionObserver a bongeszo sajat elrendezesebol dolgozik, ezert
 * fuggetlen attol, MITOL gorgett az oldal. Mivel itt csak egy osztalyt
 * kapcsolgatunk (a mozgast CSS-tranzicio vegzi, a fo szalon kivul), a
 * egy animacios konyvtar tobblettudasara nincs is szukseg.
 *
 * A sima gorgetest a bongeszo vegzi. Ehhez nem kell minden kepkockaban
 * JavaScriptet futtatni, es nem kell ket teljes animacios konyvtarat a
 * nyitocsomagba tenni.
 */

const REVEAL_MARGIN = '0px 0px -12% 0px'

export function useScrollScene(): void {
  useEffect(() => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    // Mozgascsokkentesnel be sem kapcsoljuk a rejtest: minden lathato marad.
    if (reduced) return

    const root = document.documentElement
    let observer: IntersectionObserver | null = null

    const revealAll = (): void =>
      document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'))

    try {
      // Csak most rejtjuk el a `.reveal` elemeket - amikor mar biztosan
      // van, ami ujra elohozza oket.
      root.classList.add('js-motion')

      // --- Belepes ---
      let batchIndex = 0
      let batchTimer = 0

      observer = new IntersectionObserver(
        (entries, obs) => {
          const arriving = entries.filter((e) => e.isIntersecting)
          if (!arriving.length) return

          // Egyszerre erkezo elemek 60 ms-os lepcsot kapnak; ennel
          // hosszabb kesleltetes mar lassunak hatna.
          arriving.forEach((entry) => {
            const delay = batchIndex++ * 60
            window.setTimeout(() => entry.target.classList.add('is-in'), delay)
            obs.unobserve(entry.target)
          })

          window.clearTimeout(batchTimer)
          batchTimer = window.setTimeout(() => { batchIndex = 0 }, 220)
        },
        { rootMargin: REVEAL_MARGIN, threshold: 0.01 }
      )

      document.querySelectorAll('.reveal').forEach((el) => observer!.observe(el))

      /*
        Horgonylinkek a bongeszo sajat kompozitorbarat gorgetesevel.
        A `scroll-margin` / `scroll-padding` tovabbra is CSS-ben marad.
      */
      const onAnchorClick = (e: MouseEvent): void => {
        const link = (e.target as HTMLElement).closest?.('a[href^="#"]')
        if (!link) return
        const id = link.getAttribute('href')!.slice(1)
        if (!id) return
        const target = document.getElementById(id)
        if (!target) return
        e.preventDefault()
        target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
      document.addEventListener('click', onAnchorClick)

      return () => {
        document.removeEventListener('click', onAnchorClick)
        window.clearTimeout(batchTimer)
        observer?.disconnect()
        root.classList.remove('js-motion')
      }
    } catch {
      // Ha barmi elromlik, a tartalom akkor sem tunhet el.
      root.classList.remove('js-motion')
      revealAll()
      observer?.disconnect()
      return
    }
  }, [])
}
